window.addEventListener('load', function() {
    // obtain plugin
    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        current_lang: 'it',
        autoclear_cookies: true,                   // default: false
        theme_css:  '/themes/concept/assets/resources/scss/custom/cookieconsent.css',  // 🚨 replace with a valid path
        page_scripts: true,                        // default: false
        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        auto_language: 'document',                      // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function (user_preferences, cookie) {
        // callback triggered only once on the first accept/reject action
        },

        onAccept: function (cookie) {
            // callback triggered on the first accept/reject action, and after each page load
            if(cc.allowedCategory('analytics')){
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
            if(cc.allowedCategory('targeting')){
                fbq('consent', 'grant');
            }
        },

        onChange: function (cookie, changed_categories) {
            // callback triggered when user changes preferences after consent has already been given
            if(cc.allowedCategory('analytics') === false){
                gtag('consent', 'update', {
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied'
                });
            } else {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
            if(cc.allowedCategory('targeting') === false){
                fbq('consent', 'revoke');
            } else {
                fbq('consent', 'grant');
            }
        },

        gui_options: {
            consent_modal: {
                layout: 'cloud',               // box/cloud/bar
                    position: 'bottom center',     // bottom/middle/top + left/right/center
                    transition: 'slide',           // zoom/slide
                    swap_buttons: false            // enable to invert buttons
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                    // position: 'left',           // left/right
                    transition: 'slide'            // zoom/slide
            }
        },

        languages: {
            'en': {
                consent_modal: {
                    title: 'We use cookie!',
                        description: 'Hi, this website uses essential cookie to ensure its proper operation and tracking cookie to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                        primary_btn: {
                        text: 'Accept all',
                            role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'settings',
                            role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                        save_settings_btn: 'Save settings',
                        accept_all_btn: 'Accept all',
                        reject_all_btn: 'Reject all',
                        close_btn_label: 'Close',
                        cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                        blocks: [
                        {
                            title: 'Cookie usage 📢',
                            description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies allow the website to remember the choices you have made in the past',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'google.com',
                                    col3: '2 years',
                                    col4: 'description ...',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: 'google.com',
                                    col3: '1 day',
                                    col4: 'description ...',
                                }
                            ]
                        }, {
                            title: 'Advertisement and Targeting cookies',
                            description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            }
                        }, {
                            title: 'More information',
                            description: 'Per maggiori informazioni consulta l\'informativa sulla <a href="/privacy" class="cc-link">privacy</a> e sui <a href="/cookie" class="cc-link">cookie</a>.',
                        }
                    ]
                }
            },

            'it': {
                consent_modal: {
                    title: ' I Cookie rendono le cose migliori!',
                        description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate).', //
                        primary_btn: {
                        text: 'Accetto tutti i Cookie',
                            role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Impostazioni',
                            role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Centro preferenze sulla privacy',
                        save_settings_btn: 'Salva le impostazioni',
                        accept_all_btn: 'Accetta tutti',
                        reject_all_btn: 'Rifiuta tutti',
                        close_btn_label: 'Close',
                        cookie_table_headers: [
                        {col1: 'Nome'},
                        {col2: 'Dominio'},
                        {col3: 'Scadenza'},
                        {col4: 'Tipo'}
                    ],
                        blocks: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        }, {
                            title: 'Cookie strettamente necessari',
                            description: "Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l'impostazione delle preferenze di privacy, l'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.",
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                                cookie_table: [
                                    {
                                        col1: 'october_session',       // match all cookies starting with "_ga"
                                        col2: 'concept-italy.com',
                                        col3: 'Sessione',
                                        col4: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                        is_regex: true
                                    },
                                ],
                        }, {
                            title: 'Cookie di analisi e prestazione',
                            description: 'Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono intorno al sito. Tutte le informazioni raccolte dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_ga',       // match all cookies starting with "_ga"
                                    col2: 'concept-italy.com',
                                    col3: '2 anni',
                                    col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    is_regex: true
                                },
                                {
                                    col1: '_ga_#',       // match all cookies starting with "_ga"
                                    col2: 'concept-italy.com',
                                    col3: '2 anni',
                                    col4: 'HTTP - Utilizzato da Google Analytics per raccogliere dati sul numero di volte in cui un utente ha visitato il sito web nonché date della prima e più recente visita.',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: 'concept-italy.com',
                                    col3: '1 giorno',
                                    col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.',
                                },
                                {
                                    col1: '_gat',
                                    col2: 'concept-italy.com',
                                    col3: '1 giorno',
                                    col4: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste',
                                },

                            ],

                        }, {
                                title: 'Cookie per pubblicità mirata',
                                description: 'Questi cookie possono essere impostati tramite il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma sono basati unicamente sull/individuazione del tuo browser e del tuo dispositivo internet. Se non si accettano questi cookie, riceverai una pubblicità meno mirata.',
                                toggle: {
                                    value: 'targeting',
                                    enabled: false,
                                    readonly: false
                                },
                                cookie_table: [             // list of all expected cookies
                                    {
                                        col1: '_fbp',
                                        col2: 'concept-italy.com',
                                        col3: '3 mesi',
                                        col4: 'HTTP - Utilizzato da Facebook per fornire una serie di prodotti pubblicitari come le offerte in tempo reale di terze parti inserzionisti. ',
                                        domain: "concept-italy.com"
                                    },
                                    {
                                        col1: 'mtc_id',       // match all cookies starting with "_ga"
                                        col2: 'concept-italy.com',
                                        col3: 'Sessione',
                                        col4: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.  ",
                                        domain: "concept-italy.com"
                                    },
                                    {
                                        col1: 'mautic_device_id',       // match all cookies starting with "_ga"
                                        col2: 'concept-italy.com',
                                        col3: 'Sessione',
                                        col4: "HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito web di presentare il visitatore con Pubblicità pertinente - Il servizio è fornito da centri pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti. ",
                                        domain: "concept-italy.com"
                                    },
                                    {
                                        col1: 'mautic_referer_id',       // match all cookies starting with "_ga"
                                        col2: 'concept-italy.com',
                                        col3: '1 giorno',
                                        col4: "HTTP - Raccoglie informazioni sul comportamento degli utenti su più siti web. Queste informazioni vengono utilizzate per ottimizzare la pertinenza della pubblicità sul sito web.",
                                        domain: "concept-italy.com"
                                    },
                                    {
                                        col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                        col2: 'concept-italy.com',
                                        col3: 'Sessione',
                                        col4: "HTTP - Utilizzato per tracciare i visitatori su più siti Web, al fine di visualizzare annunci pubblicitari recenti pertinenti in base alle preferenze del visitatore.",
                                        domain: "concept-italy.com"
                                    },
                                ]
                            }, {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta l\'informativa sulla <a href="/privacy-policy" class="cc-link">privacy</a> e sui <a href="/cookie-policy" class="cc-link">cookie</a>.',
                        }
                    ]
                }
            }
        }

    });

});
